// @flow

import React, { useCallback, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import { ApEdit, ApDelete } from '../Icons';
import Organization from './styles';
import dateFns from 'date-fns';
import Chip from '../Chip';
import { isImperial } from 'services/Units/thunks';
import { deleteMaintenanceInformation } from 'services/Report/thunks';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import ParticularMaintenance from '../../containers/Maintenance/ParticularMaintenance';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
    data: Object<any>,
    columns: Array<ColumnType>,
    intl: Object,
};

const OrganizationListItem = (props: Props) => {
    const { data, vehicleId, intl } = props;
    const [isModalMaintenanceOpen, setIsModalMaintenanceOpen] = useState(false);
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleCancel = () => {
        props.deleteMaintenanceInformation(data.get('id'));
        setOpen(false);
    };

    const hashCode = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    };

    const intToARGB = (i) => {
        let hex =
            ((i >> 24) & 0xff).toString(16) +
            ((i >> 16) & 0xff).toString(16) +
            ((i >> 8) & 0xff).toString(16) +
            (i & 0xff).toString(16);
        hex += '000000';
        return hex.substring(0, 6);
    };

    const convertStringToColor = (str) => {
        if (!str) return '';
        str = str.replace(/\s+/g, '');
        return `#${intToARGB(hashCode(str))}`;
    };

    const hexToHSL = (H) => {
        // Convert hex to RGB first
        let r = 0;
        let g = 0;
        let b = 0;
        if (H.length == 4) {
            r = `0x${H[1]}${H[1]}`;
            g = `0x${H[2]}${H[2]}`;
            b = `0x${H[3]}${H[3]}`;
        } else if (H.length == 7) {
            r = `0x${H[1]}${H[2]}`;
            g = `0x${H[3]}${H[4]}`;
            b = `0x${H[5]}${H[6]}`;
        }
        // Then to HSL
        r /= 100;
        g /= 280;
        b /= 100;
        const cmin = Math.min(r, g, b);
        const cmax = Math.max(r, g, b);
        const delta = cmax - cmin;
        let h = 0;
        if (delta == 0) h = 0;
        else if (cmax == r) h = ((g - b) / delta) % 6;
        else if (cmax == g) h = (b - r) / delta + 2;
        else h = (r - g) / delta + 4;
        h = Math.round(h * 60);
        if (h < 0) h += 360;

        return `hsl(${h},${80}%,${60}%)`;
    };
    const handleEditMaintenance = () => {
        setIsModalMaintenanceOpen(true);
        // Handle edit maintenance logic here
    };
    const handleCancelMaintenance = () => {
        setIsModalMaintenanceOpen(false);
    };
    const dateFormat = useCallback(
        (datestart) => {
            let dayOfWeek = dateFns.format(datestart, 'dddd');
            const dayMapping = {
                Monday: 'containers.Reports.Generators.move.Monday',
                Tuesday: 'containers.Reports.Generators.move.Tuesday',
                Wednesday: 'containers.Reports.Generators.move.Wednesday',
                Thursday: 'containers.Reports.Generators.move.Thursday',
                Friday: 'containers.Reports.Generators.move.Friday',
                Saturday: 'containers.Reports.Generators.move.Saturday',
                Sunday: 'containers.Reports.Generators.move.Sunday',
            };
            dayOfWeek = intl.formatMessage({ id: dayMapping[dayOfWeek] });
            return `${dayOfWeek} ${dateFns.format(datestart, 'YYYY/MM/DD')}`;
        },
        [intl]
    );
    let rowSpan = 8;
    const horometer = data.get('Horometre')
        ? parseFloat(data.get('Horometre')).toFixed(2) / 3600
        : 0;
    const conversionFactor = props.isImperial() ? 1609.344 : 1000;
    const odometer = data.get('Odometre')
        ? (parseFloat(data.get('Odometre')) / conversionFactor).toFixed(2)
        : 0;
    return (
        <Organization>
            <ParticularMaintenance
                isModalMaintenanceOpen={isModalMaintenanceOpen}
                handleCancelMaintenance={handleCancelMaintenance}
                editData={data}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <FormattedMessage id="modals.Maintenance.deleteTitle" />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <FormattedMessage id="modals.Maintenance.deleteConfirmation" />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} className={'refuse_btn'}>
                        <FormattedMessage id={'components.ap.delete.Confirmation.No'} />
                    </Button>
                    <Button onClick={handleCancel} autoFocus className={'agree_btn'}>
                        <FormattedMessage id={'components.ap.delete.Confirmation.Yes'} />
                    </Button>
                </DialogActions>
            </Dialog>
            <Organization.Griditem rowSpan={rowSpan}>
                <Organization.datetime>{dateFormat(data.get('Date'))}</Organization.datetime>
                <Organization.trajet>{data.get('NumeroDeFacture')}</Organization.trajet>

                <Organization.trajet>{data.get('TypeVehicule')}</Organization.trajet>
                <Organization.datetime>
                    {dateFns.format(data.get('DateEntree'), 'YYYY/MM/DD')}
                </Organization.datetime>
                <Organization.totaldistance>
                    {data.get('technicianName') ? (
                        <Chip
                            type="driver"
                            color={hexToHSL(convertStringToColor(data.get('technicianName')))}
                        >
                            &nbsp;
                            {data.get('technicianName')}
                        </Chip>
                    ) : (
                        <empty />
                    )}
                    &nbsp;&nbsp;
                </Organization.totaldistance>
                <Organization.trajet>{data.get('Departement')}</Organization.trajet>
                <Organization.odometer>{odometer}</Organization.odometer>
                <Organization.trajet>{data.get('EntretienCommentaire')}</Organization.trajet>
            </Organization.Griditem>
            <Organization.Griditem rowSpan={rowSpan}>
                <Organization.trajet>
                    <Button className={'edit'} onClick={handleEditMaintenance}>
                        <ApEdit
                            title={props.intl.formatMessage({
                                id: 'containers.AP.Home.Buttons.edit',
                            })}
                        />
                    </Button>
                    <Button className={'delete'} onClick={handleClickOpen}>
                        <ApDelete />
                    </Button>
                </Organization.trajet>

                <Organization.trajet>{data.get('Cout')}</Organization.trajet>
                <Organization.empty />
                <Organization.datetime>
                    {dateFns.format(data.get('DateSortie'), 'YYYY/MM/DD')}
                </Organization.datetime>
                <Organization.trajet>{data.get('TypeReparation')}</Organization.trajet>
                <Organization.trajet>{data.get('Garage')}</Organization.trajet>
                <Organization.horometer>{horometer}</Organization.horometer>
                <Organization.empty />
            </Organization.Griditem>
        </Organization>
    );
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            isImperial,
            deleteMaintenanceInformation,
        },
        dispatch
    );

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(injectIntl(OrganizationListItem))
);
